import axios from 'axios';
import config from '../config.json';

import {
  SET_USERNAME,
  SET_PASSWORD,
  LOGIN_USER_START,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAIL,
  CHANGE_PASSWORD,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAIL,
  CLOSE_CHANGE_PASSWORD,
  LOGOUT_USER,
  SET_LOGIN_ERROR,
  SESSION_EXPIRED,
} from './types';

const API_URL = process.env.REACT_APP_BACKEND || config.backend;

export const setUsername = (username) => {
  return {
    type: SET_USERNAME,
    payload: username
  }
};

export const setPassword = (password) => {
  return {
    type: SET_PASSWORD,
    payload: password
  }
};

export const setLoginError = (error) => {
  return {
    type: SET_LOGIN_ERROR,
    payload: error
  }
};

// eslint-disable-next-line
export const loginUser = ( username, password ) => {
  return async ( dispatch ) => {
    dispatch({ type: LOGIN_USER_START })

    await axios({
      method: 'post',
      url: API_URL + 've/login',
      data: {
        username: username,
        password: password
      }
    }).then( async response => {
      if (response.data.changePassword) {
        return dispatch({
          type: CHANGE_PASSWORD,
          user: response.data.user,
        })
      }

      // user data
      const user = response.data.user

      // data that user has access to
      const customers = response.data.customers
      const projects = response.data.projects
      const devices = response.data.devices
      const cameras = response.data.cameras
      const userViews = response.data.userViews

      // for connecting to backend/API
      const token = response.data.token
      const deviceIdList = response.data.deviceIdList
      const backendVersion = response.data.backendVersion

      // get default user view
      let defaultUserView = {}
      const localDefaultViews = await localStorage.getItem('defaultViews')
      const localViews = localDefaultViews && localDefaultViews.length > 0 ? JSON.parse(localDefaultViews) : []
      if (localViews && localViews.length > 0 && localViews.find(v => v.id === response.data.user.bID)) {
        let tView = await localViews.find(v => v.id === response.data.user.bID)
        if (tView && tView.id) {
          defaultUserView = userViews.find(uv => uv.id === tView.viewId)
        }
      }

      // login the user
      dispatch({
        type: LOGIN_USER_SUCCESS,
        user: user,
        userViews: userViews,
        customers: customers,
        deviceIdList: deviceIdList,
        devices: devices,
        projects: projects,
        cameras: cameras,
        token: token,
        autoLogin: false,
        defaultUserView: defaultUserView,
        backendVersion: backendVersion,
      })

    }).catch( error => {
      console.log(error)
      dispatch({
        type: LOGIN_USER_FAIL
      })
    })
  }
};

export const changePassword = (id, oldPassword, newPassword) => {
  return async ( dispatch ) => {
    await axios({
      method: 'post',
      url: API_URL + 've/changepassword',
      data: {
        id,
        oldPassword,
        newPassword,
      }
    }).then( async response => {
      return dispatch({
        type: CHANGE_PASSWORD_SUCCESS,
      })

    }).catch( error => {
      return dispatch({
        type: CHANGE_PASSWORD_FAIL,
        loginError: error.response.data.error
      })
    })
  }
};

export const closeChangePassword = (value) => {
  return {
    type: CLOSE_CHANGE_PASSWORD,
  }
}

export const verifyUserValidity = (deviceIdList, user) => {
  // this will check if the deviceIdList that we have is still the same in the database
  // if not, that means the user data has been updated so let's force logout to get the latest changes to avoid inconsistent data
  return async ( dispatch ) => {
    await axios({
      method: 'get',
      url: `${API_URL}ve/verifyuser?devices=${deviceIdList.join(':')}&id=${user.bID}`,
    }).then(async response => {
      if (response.data.expired === true) {
        // this usually happens when a user access has been modified by another user on a different session
        // and when there are inconsistencies in the states, it causes a blank page or silent access denied failures

        // this could be optimized further to update state.data with the latest values that are in the db instead of logging out
        // but for now, I'm not sure of the extent of changes that needs to be updated, or its effect once updated
        // so to get a clean valid state values, let's just log out and ask the user to re-login
        dispatch({
          type: SESSION_EXPIRED,
        })
      }
    })
  }
}

export const logoutUser = () => {
  return async ( dispatch ) => {
    //  await localStorage.removeItem('defaultViews');
    dispatch({
      type: LOGOUT_USER,
    });
  }
};



